// /teachers 코드 → 라벨 / 색 매핑 (route-local 도메인 지식).

import type { StatusChipColor } from "components/list";

interface StatusMeta {
  label: string;
  color: StatusChipColor;
}

// 권한(auth)
export const authMeta: Record<string, StatusMeta> = {
  DIRECTOR: { label: "시설 관리자", color: "primary" },
  TEACHER: { label: "교사", color: "default" },
};

// 승인상태(approval)
export const approvalMeta: Record<string, StatusMeta> = {
  ACCEPT: { label: "완료", color: "success" },
  WAITING: { label: "대기 중", color: "warning" },
  REJECT: { label: "거절", color: "error" },
};

// 매핑에 없는 값도 안전하게 표시 (기존 default: 원본 값 그대로 노출)
export const resolveStatusMeta = (
  map: Record<string, StatusMeta>,
  value: unknown
): StatusMeta => {
  const key = value === null || value === undefined ? "" : String(value);
  return map[key] ?? { label: key || "-", color: "default" };
};
